import React from "react";
import { useTranslation } from "react-i18next";

import { version } from "utils/version";

import * as S from "./styles";

const Footer = () => {
  const { t } = useTranslation("common");

  return (
    <S.Footer>
      {t("copyright")} - v{version}
    </S.Footer>
  );
};

export default Footer;
